import * as S from './Collapsable.styles';
import Icon from '../icon/Icon';
import Card from '../card/Card';
import { useEffect, useState } from 'react';
import P from '../texts/p/P';

const defaultProps = {
  startOpened: true,
  iconVariant: 'neutral',
  variant: 'none',
  modifier: 'regular',
};

type CollapsableProps = {
  id?: string;
  title: string;
  rightTitle?: string;
  children: any;
  startOpened: boolean;
  forceOpen?: boolean;
  hideToggle?: boolean;
  iconVariant?: Parameters<typeof Icon>[0]['variant'];
  titleVariant?: Parameters<typeof P>[0]['variant'];
  titleModifier?: Parameters<typeof P>[0]['modifier'];
  rightTitleVariant?: Parameters<typeof P>[0]['variant'];
  rightTitleModifier?: Parameters<typeof P>[0]['modifier'];
  variant?: 'none' | 'primary' | 'secondary' | 'neutral' | 'warning' | 'success';
  modifier?: 'regular' | 'weak';
  headerStyle?: (open: boolean) => React.CSSProperties;
} & typeof defaultProps;

const Collapsable = (props: CollapsableProps) => {
  const [open, setOpen] = useState(props.forceOpen || props.startOpened);
  const toggle = () => setOpen(!open);

  const {
    id,
    title,
    children,
    rightTitle,
    titleVariant = 'neutral-1',
    titleModifier = 'strong',
    rightTitleVariant = 'neutral-1',
    rightTitleModifier = 'strong',
    iconVariant = 'neutral',
    forceOpen = false,
    hideToggle = false,
    variant = 'none',
    modifier = 'regular',
    headerStyle,
  } = props;

  useEffect(() => {
    if (forceOpen) {
      setOpen(true);
    }
  }, [forceOpen]);

  return (
    <S.Collapsable
      data-testid={id}
      id={id}
      title={title}
      variant={variant}
      modifier={modifier}
    >
      <Card
        display='flex'
        justifyContent='space-between'
        onClick={!hideToggle ? toggle : undefined}
        style={{
          ...(!hideToggle ? { cursor: 'pointer' } : {}),
          ...(headerStyle?.(open) || {}),
        }}
      >
        <P
          type='1'
          variant={titleVariant}
          withMargin={false}
          weight='bold'
          modifier={titleModifier}
        >
          {title}
        </P>
        <Card display='flex' gap='16px'>
          <P
            type='1'
            variant={rightTitleVariant}
            withMargin={false}
            weight='bold'
            modifier={rightTitleModifier}
          >
            {rightTitle}
          </P>
          {!hideToggle && (
            <Icon
              name={open ? 'chevron_up_outline' : 'chevron_down_outline'}
              height={20}
              width={20}
              variant={iconVariant}
            />
          )}
        </Card>
      </Card>
      {open && children}
    </S.Collapsable>
  );
};

Collapsable.defaultProps = defaultProps;

export default Collapsable;
